import { scrollTo } from 'JBPlugin/scroll-to';

jQuery($ => {
	const $pageScrollNav = $('.page-scroll-nav');
	let html = [],
		scrollNav,
		container,
		headings,
		label,
		id,
		hasItem;

	if ($pageScrollNav.length) {
		$pageScrollNav.each(function() {
			scrollNav = $(this);
			html = [];
			container = $(this).data('container') ? $(this).data('container') : $('body');
			headings = $('[data-page-scroll-item]').length ? '[data-page-scroll-item]' : 'h2';

			if(container.find(headings).length && headings === '[data-page-scroll-item]' || (container.find(headings).length > 1 && headings !== '[data-page-scroll-item]')){
				container.find(headings).each(function() {
					label =
						$(this).data('page-scroll-item') && $(this).data('page-scroll-item') != ''
							? $(this).data('page-scroll-item')
							: $(this).text();
					id = $(this).attr('id') ? $(this).attr('id') : _.camelCase(label);
					$(this).attr('id', id);
					html.push('<a class="badge badge-info badge-nav page-scroll-to" href="#' + id + '">' + label + '</a>');
					hasItem = true;
				});
				scrollNav.html(html.join('\n'));
			}
		});

		$(document).on('click', '.page-scroll-to', function(e) {
			e.preventDefault();
			scrollTo($(this).attr('href'));
		});

		if (hasItem) {
			$('.container.department').addClass('has-anchors');
		}
	}
});
